module.exports = __webpack_public_path__ + "img/addForm.66d8f841.png";